import { GuidedChangeEventStep } from "src/routes/projects/change-events/guided/utils";
import {
  WorkflowActionArgs,
  WorkflowActions,
  WorkflowPageActionArgs,
} from "src/routes/projects/change-events/guided/workflows/types";
import { useGuidedChangeEventActions } from "../sharedSteps/useGuidedChangeEventActions";
import { ApplyConfigurationFormInput } from "./applyConfigurationForm";

/** Saves the apply configuration change event. */
export function useSaveApplyConfigurationChangeEvent(args: WorkflowActionArgs<ApplyConfigurationFormInput>) {
  const { saveChangeEvent } = useGuidedChangeEventActions(args, (form) => ({
    readyPlanId: form.readyPlanId.value,
    originalReadyPlanId: form.originalReadyPlanId.value,
    checkoutConfigId: form.checkoutConfigId.value,
    originalReadyPlanOptions: form.originalReadyPlanOptions.changedValue,
    proposedReadyPlanOptions: form.proposedReadyPlanOptions.changedValue,
  }));
  return { saveChangeEvent };
}

/** The actions the initial and partial apply-configuration workflows share. */
export function useApplyConfigurationActions(
  args: WorkflowPageActionArgs<ApplyConfigurationFormInput>,
): WorkflowActions {
  const { form, project } = args;
  const { saveChangeEvent } = useSaveApplyConfigurationChangeEvent(args);
  return {
    // TODO: submit the change event for the apply-configuration flow.
    onSubmit: async () => {},
    onContinue: {
      [GuidedChangeEventStep.SelectConfiguration]: async () => {
        // With no signed contract the configuration is applied directly later, so there is no draft
        // to create; the selection rides along in form state for step 2.
        if (!project.latestActiveStage?.hasSignedContract) return;
        await saveChangeEvent();
      },
    },
    onSaveAndExit: form.value.id ? () => saveChangeEvent({ andExit: true }) : undefined,
  };
}
